import { UseMeResponse } from "@/hooks/use-me-query";

const selectWizardStep = (data: UseMeResponse) => data.meta?.wizardStep;

export default selectWizardStep;
